module.exports = __webpack_public_path__ + "static/assets/0aece143582fbdd803c462d1637d2987.svg";